import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import HeroCarousel from "@/components/HeroCarousel";
import CategoriesGrid from "@/components/CategoriesGrid";
import RequirementsForm from "@/components/RequirementsForm";
import AboutUs from "@/components/AboutUs";
import Footer from "@/components/Footer";
import { useAuth } from "@/contexts/AuthContext";
import { VENDOR_PRODUCT_OPTIONS } from "@/lib/productOptions";
import { Analytics } from "@/lib/analyticsShim";

function getVendorProductPath(productSlug) {
  const rawSlug = String(productSlug || "").trim();
  if (!rawSlug) return null;
  const normalizedSlug = rawSlug.toLowerCase() === "di-pipes" ? "pvc-pipes" : rawSlug;
  const option = VENDOR_PRODUCT_OPTIONS.find(
    (item) => item.slug.toLowerCase() === normalizedSlug.toLowerCase()
  );
  return `/products/${option?.routeSlug || normalizedSlug}`;
}

export default function Landing() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && user?.role === "admin") {
      navigate("/admin-dashboard", { replace: true });
      return;
    }

    if (!loading && user?.role === "vendor" && !location.hash) {
      const vendorProductPath = getVendorProductPath(user.vendor_product_slug);
      if (vendorProductPath) {
        navigate(vendorProductPath, { replace: true });
      }
    }
  }, [user, loading, navigate, location.hash]);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 150);
    }
  }, [location.hash]);

  return (
    <div className="bg-white min-h-screen" data-testid="landing-page">
      <Navbar />
      <HeroCarousel />
      <CategoriesGrid />
      <RequirementsForm />
      <AboutUs />
      <Footer />
    </div>
  );
}
